import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { TextField, IconSearch } from 'uikit';

import { useDebounce } from '@consta/uikit/useDebounce';
import type React from 'react';
import { useCallback, useState } from 'react';

import type { ICheckedChangeItem } from './hooks/usePriceListUerForTechPartRatioColumns';
import { usePriceListUerForTechPartRatioColumns } from './hooks/usePriceListUerForTechPartRatioColumns';
import { usePriceListUerForTechPartRatioData } from './hooks/usePriceListUerForTechPartRatioData';

import Styles from './ApplicationAreaSelector.module.css';

interface IPriceListUerForTechPartRatioTable {
    onRowCheckedChange: (changeState: ICheckedChangeItem[]) => void;
    checkedIds: number[];
    disabledIds: number[];
}

export const PriceListUerForTechPartRatioTable: React.FC<IPriceListUerForTechPartRatioTable> = (props) => {
    const { checkedIds, onRowCheckedChange, disabledIds } = props;

    const [searchValue, setSearchValue] = useState<string>('');
    const [debounceSearchValue, setDebounceSearchValue] = useState<string>('');

    const onSearchDebouncedSearchValueChange = useDebounce((v) => {
        setDebounceSearchValue(v);
    }, 700);

    const onSearchValueChange = useCallback(
        ({ value }) => {
            setSearchValue(value);
            onSearchDebouncedSearchValueChange(value);
        },
        [onSearchDebouncedSearchValueChange],
    );

    const [currentFilters, setCurrentFilters] = useState<Record<string, string[]> | null>(null);

    const { dataSource } = usePriceListUerForTechPartRatioData({
        searchValue: debounceSearchValue,
        currentFilters,
    });

    const onFiltersUpdated = useCallback(
        ({ fieldName, checkedValues }: { fieldName: string; checkedValues: string[] }) => {
            setCurrentFilters((prev) => ({
                ...prev,
                [fieldName]: checkedValues,
            }));
        },
        [],
    );

    const columns = usePriceListUerForTechPartRatioColumns({
        onRowCheckedChange,
        checkedIds,
        disabledIds,
        onFiltersUpdated,
    });

    return (
        <>
            <TextField
                className={Styles.search}
                placeholder="Поиск расценки в прейскуранте"
                leftSide={IconSearch}
                value={searchValue}
                onChange={onSearchValueChange}
                withClearButton
            />
            <AgGridTable
                columnDefs={columns}
                datasource={dataSource}
                rowModelType="infinite"
                maxConcurrentDatasourceRequests={1}
                maxBlocksInCache={50}
                cacheBlockSize={50}
                key={debounceSearchValue}
            />
        </>
    );
};

PriceListUerForTechPartRatioTable.displayName = 'PriceListUerForTechPartRatioTable';
